module.exports = __webpack_public_path__ + "img/VP-Lite-Profiles.cb915944.jpg";